import React, { useState, useEffect } from "react";
import "./QuestionHome.scss";
import QuesBody from "./QuesBody";
import { getToken } from "../../auth/authConfig";
import QuestionSkeleton from "./QuestionSkeleton";
import QuestionError from "./QuestionError";
import LoadingScreen from "../../reusables/LoadingScreen";
import Error403 from "../../reusables/Error403";

// const ENDPOINT_BASE = process.env.REACT_APP_SERVER_URL + "/super/getProtocol/";
const ENDPOINT_BASE =
  `${process.env.REACT_APP_SERVER_URL}/super/getProtocol/`;
const ENDPOINT_STATUS = "?status=";

const TABS_CONFIG = [
  { label: "Addendum", endpoint: "Addendum" },
  { label: "Full Scope", endpoint: "Full Scope" },
  { label: "Gap Assessment", endpoint: "Gap Assessment" },
];

const QuestionHome = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [questionsData, setQuestionsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formType, setFormType] = useState("");
  const [formStatus, setFormStatus] = useState("");
  const [accessPage, setAccessPage] = useState(true);

  const fetchData = async (formStatusFlag) => {
    setError(null);
    setLoading(true);
    const endpoint = `${ENDPOINT_BASE}${TABS_CONFIG[activeTab].endpoint}${ENDPOINT_STATUS}${formStatusFlag}`;
    const token = await getToken();

    try {
      const res = await fetch(endpoint, {
        headers: {
          "oidc-token": token,
          Accept: "application/json",
        },
      });
      if (res.status === 403) {
        setAccessPage(false);
        throw new Error("Access forbidden");
      }
      if (!res.ok) throw new Error("Failed to fetch data");
      const data = await res.json();

      if (formStatusFlag === "Draft" && data?.error === "Form Not Found") {
        setFormStatus("Draft");
      } else {
        setQuestionsData(data?.data || []);
        setFormType(data?.form_type || TABS_CONFIG[activeTab].label);
        
        if (formStatusFlag === "Publish") {
          setFormStatus("Publish");
        }
      }

      setError(null);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 403) {
        setAccessPage(false);
      }
    
    
      setError(error.message || "Unknown error");
      setLoading(false);
      setQuestionsData([]); 
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("Publish");
  }, [activeTab]);


  const TABS = TABS_CONFIG.map((tab, idx) => ({
    label: tab.label,
    component: (
      <QuesBody
        title={formType}
        quesData={questionsData}
        setQuestionsData={setQuestionsData}
        formType={tab.label}
        formStatus={formStatus}
        setFormStatus={setFormStatus}
      />
    ),
  }));

  useEffect(() => {
    if (formStatus === "Draft") fetchData("Draft");
  }, [formStatus]);

  if (loading) {
    return (
      <div className="h-[80vh]">
        <LoadingScreen />
      </div>
    );
  }
  return (
    <>

    {!accessPage && (
      <>
       <div className="flex items-center justify-center h-[80vh]">
            <Error403 />
          </div>
      </>
    )}
    
    {accessPage && (

    <div id="question-home">
      <div className="ques-main-container">
        <div className="ques-menu">
          <div className="ques-menu-cont">
            {TABS.map((tab, idx) => (
              <button
                key={tab.label}
                className={`ques-tab ${activeTab === idx ? "ques-active" : ""}`}
                onClick={() => setActiveTab(idx)}
                type="button"
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        {error ? (
          <QuestionError error={error} onRetry={fetchData} />
        ) : loading ? (
          <QuestionSkeleton />
        ) : (
          TABS[activeTab].component
        )}
      </div>
    </div>

)}


    </>

  );
};

export default QuestionHome;
